import { Input } from '@/components/ui/input';
import { inputFields } from './rocketNozzleFields';
import type { InputKey, InputState } from './types';

interface OutputField {
  label: React.ReactNode;
  unit: React.ReactNode;
  value: string;
}

interface RocketNozzleFormProps {
  enabled: boolean;
  inputs: InputState;
  setInput: (key: InputKey, v: string) => void;
  outputFields: OutputField[];
}

export function RocketNozzleForm({
  enabled,
  inputs,
  setInput,
  outputFields,
}: RocketNozzleFormProps) {
  return (
    <>
      <img
        src="/rocket-hotfire-banner.png"
        alt="Rocket Hotfire"
        className="mt-3 w-full rounded-lg object-cover"
      />
      <div className="mt-4">
        <p className="mb-1 text-sm font-semibold text-telekinesis-text-primary">
          Parameters (Convergent Divergent de Laval Nozzle)
        </p>
        <div className="grid grid-cols-1 gap-y-3 md:grid-cols-2 md:gap-x-16">
          {inputFields.map((field) => (
            <div key={field.key} className="flex items-center">
              <span className="min-w-0 flex-1 pr-3 text-xs text-telekinesis-text-primary">
                {field.label}
              </span>
              <div className="flex shrink-0 items-center gap-1.5">
                <Input
                  type="number"
                  step="any"
                  disabled={!enabled}
                  value={inputs[field.key]}
                  onChange={(e) => setInput(field.key, e.target.value)}
                  className="h-7 w-20 rounded-md px-2 text-center text-xs text-[#107d40]"
                />
                <span className="w-16 text-right text-xs text-telekinesis-text-secondary">
                  {field.unit}
                </span>
              </div>
            </div>
          ))}
        </div>

        <p className="mb-1 mt-6 text-sm font-semibold text-telekinesis-text-primary">
          Theoretical Performance
        </p>
        <div className="grid grid-cols-1 gap-y-3 md:grid-cols-2 md:gap-x-16">
          {outputFields.map((field, i) => (
            <div key={i} className="flex items-center">
              <span className="min-w-0 flex-1 pr-3 text-xs text-telekinesis-text-primary">
                {field.label}
              </span>
              <div className="flex shrink-0 items-center gap-1.5">
                <Input
                  type="text"
                  readOnly
                  value={field.value}
                  onChange={() => {}}
                  className="h-7 w-20 cursor-default rounded-md px-2 text-center text-xs text-[#107d40] opacity-80"
                />
                <span className="w-16 text-right text-xs text-telekinesis-text-secondary">
                  {field.unit}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
}
